import React, { useState, useEffect } from "react";
import { TextField } from '@mui/material';

export default function MultilineRegulationsTextArea(props: any) {

    const {
        handleCurrentChange,
        value,
        regulationType,
        label,
        additionalStyle,
        disabled
    } = props;

    const Wheel =(e: any) => {
        e.target.blur();
    }

    const defaultStyle = {
        padding: "10px 0px",
        marginRight: "17px",
        marginTop: "17px",
        width: "433px"
    };

    return (
        <TextField
            style={additionalStyle || defaultStyle}
            multiline
            variant="standard"
            label={label ? label : 'Regulations'}
            value={value} 
            type='text'
            disabled={disabled}
            onChange={(e) => { handleCurrentChange(e.target.value, regulationType) }}
            onWheel={e => Wheel(e)}
            InputLabelProps={{ style: { fontSize: "14px" } }}
            InputProps={{ style: { padding: "7px 0px" } }}
        />
    )
}